<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="assign">
      <span>{{ "Create Trip" | translate }} </span>
      <i class="material-icons" (click)="closeDialog()"> clear </i>
    </div>
    <div class="bodySection">
      <div class="spot_driver_search">
        <div class="left_sec">
          <div class="search_text">{{ "Trip Type" | translate }}</div>
        <div class="search_sec">
          <mat-select [(value)]="selected">
            <mat-option value="PRIMARY">Primary</mat-option>
            <mat-option value="SECONDARY">Secondary</mat-option>
          </mat-select>
        </div>
        </div>
        <div class="center_sec">
          <div class="search_text">{{'ASSIGN.search' | translate}}</div>
        <div class="search_sec">
            <div class="input-container">
                <input class="inputSelect" min="0" (keyup)="applyFilter($event.target.value,'mobile')"
                    [(ngModel)]="mobile_number" name="filter" placeholder="Driver Mobile No." type="number">
                <span class="close_img" *ngIf="mobile_number" (click)="clearMobileNumber()"><i
                        class="material-icons" id="material-icons-close">
                        clear
                    </i></span>
            </div>
            <div class="input-container">
                <input class="inputSelect" (keyup)="applyFilter($event.target.value,'vehicleno')"
                    [(ngModel)]="vehicle_number" name="filter" placeholder="Vehicle No." type="text">
                <span class="close_img" *ngIf="vehicle_number" (click)="clearVehicleNumber()"><i
                        class="material-icons" id="material-icons-close">
                        clear
                    </i></span>
            </div>
        </div>
        </div>
        
        <div class="right_sec">
          <div class="spotButton" appDbclick (debounceClick)="openSpotDriver()">
            <div class="button">
              <img src="assets/spotdriver-indigo.svg" alt="" />
              <span class="label">
                {{ "ASSIGN.spotDriver" | translate }}
              </span>
            </div>
          </div>
        </div>
        
      </div>

      <div class="assignSection">
        <div class="tableSection">
            <table mat-table *ngIf="assignArr.length;else noFreeDrivers" [dataSource]="assignArr" class="table">
                <ng-container matColumnDef='select'>
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [(ngModel)]="selectAll">
                        </mat-checkbox> -->
                        {{'ASSIGN.select' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <mat-checkbox [checked]=" element.select"  [(ngModel)]="element.select"
                            [indeterminate]="element.select">
                        </mat-checkbox> -->
                        <mat-checkbox  (change)="selectCheckbox($event, element)" [(ngModel)]="element.select"></mat-checkbox>
                        <!-- <mat-radio-button   [(ngModel)]="element.select"></mat-radio-button> -->
                    </td>
                </ng-container>
                <ng-container matColumnDef='vehicle'>
                    <th mat-header-cell *matHeaderCellDef> {{'ASSIGN.vehicle' | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <div>
                            {{element.vehicle}} <img src="assets/VehicleMaintenance.svg"
                                *ngIf="element.in_service" alt="" class="icon" style="width: 15px;"
                                title="{{'VEHICLE.in_maintenance' | translate}}">
                        </div>
                        <div style="padding:3px;margin-top:5px;color:#888; font-size:10px"
                            *ngIf="element.vehicle_type.name">
                            {{element.vehicle_type.name}}
                        </div>
                        <div style="padding:3px;margin-top:5px;color:#888; font-size:10px"
                            *ngIf="!element.vehicle_type.name">
                            {{element.vehicle_type}}
                        </div>
                        <div style="padding:3px;margin-top:5px;color:#888; font-size:10px">
                            {{element.unitname}}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef='driverName'>
                    <th mat-header-cell *matHeaderCellDef>{{'ASSIGN.driverName' | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <div>
                            <span *ngIf="element.is_temporary">
                                <img src="assets/spotdriver-indigo.svg" alt="" height="15px" width="15px"
                                    title="Spot Driver">
                            </span>
                            {{element.driverName}}
                        </div>
                        <div class="driver_mobile">
                            {{element.driverMobile}}
                        </div>
                        <div *ngIf="element.assigned_shipment" style="margin-top: 2px;">
                            <div class="assigned">{{'ASSIGN.assigned' | translate}}</div>
                            <div class="not-accepted">{{'ASSIGN.not_accepted' | translate}}</div>
                        </div>
                        <div *ngIf="!element.assigned_shipment" style="margin-top: 2px;">
                            <div class="free">{{'ASSIGN.free' | translate}}</div>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef='weight'>
                    <th mat-header-cell *matHeaderCellDef>{{'ASSIGN.weight' | translate}}
                        ({{parentData.order.uom | titlecase}})</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field class="" style="width: 100px; margin-left: 10px;">
                            <input matInput placeholder="Weight" [(ngModel)]="element.weight">
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef='pallet'>
                    <th mat-header-cell *matHeaderCellDef>{{'ASSIGN.pallet' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field class="" style="width: 100px; margin-left: 10px;">
                            <input type="number" matInput placeholder="Pallet" [(ngModel)]="element.pallet">
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef='distance'>
                    <th mat-header-cell *matHeaderCellDef> {{'ASSIGN.distance' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.distance}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnHeaders; sticky: true;"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnHeaders"></tr>
            </table>
            <mat-paginator [length]="(assignArr)? totalAssigned : 0" [pageSizeOptions]="[5,10,25,50,100]"
                showFirstLastButtons (page)="pageNavigate($event);"></mat-paginator>
        </div>

        <div class="map_tab">
            <div class="tableSection">
                <table mat-table [dataSource]="dataSource" matSort>
                  <ng-container matColumnDef="shipment">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">
                      {{ "EXPRESS_DETAILS.shipment_id" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.shipment }}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="drop_location">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">
                      {{ "EXPRESS_DETAILS.delivery" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.drop_location }}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="booking_date">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">
                      {{ "EXPRESS_DETAILS.booking_date" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.booking_date }}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="packages">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">
                      {{ "EXPRESS_DETAILS.packages" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.packages }}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">
                      {{ "EXPRESS_DETAILS.weight" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.weight }}
                    </td>
                  </ng-container>
      
                  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                  <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                  </tr>
                </table>
              </div>
        </div>


        <ng-template #noFreeDrivers>
            <div class="noShipments" style="padding-top: 30px; text-align: center; color:#D8511F">
                {{'ASSIGN.noFreeDrivers' | translate}}
            </div>
        </ng-template>

    </div>

      <!-- <div class="assignSection">
        <div class="tableSection">
          <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="shipment">
              <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "EXPRESS_DETAILS.shipment_id" | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.shipment }}
              </td>
            </ng-container>

            <ng-container matColumnDef="drop_location">
              <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "EXPRESS_DETAILS.delivery" | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.drop_location }}
              </td>
            </ng-container>

            <ng-container matColumnDef="booking_date">
              <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "EXPRESS_DETAILS.booking_date" | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.booking_date }}
              </td>
            </ng-container>

            <ng-container matColumnDef="packages">
              <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "EXPRESS_DETAILS.packages" | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.packages }}
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "EXPRESS_DETAILS.weight" | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.weight }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
        </div>

        <div class="map_tab">
          <div class="mapSection">
            <div class="label">
              <div class="currentLocation">
                {{ "ASSIGN.currentLocation" | translate }}
              </div>
            </div>
            <div class="map" id="pathMap"></div>
          </div>
          <div class="delivery">
            <div
              *ngFor="let delivery of deliveries; let i = index"
              class="pdSpan"
            >
              <b class="drop">D{{ i + 1 }}</b> - {{ delivery.loc_id.name }} -
              {{ delivery.loc_id.city }}<br />
             
            </div>
          </div>
        </div>

        <ng-template #noFreeDrivers>
          <div
            class="noShipments"
            style="padding-top: 30px; text-align: center; color: #d8511f"
          >
            {{ "ASSIGN.noFreeDrivers" | translate }}
          </div>
        </ng-template>
      </div> -->

      <!-- <div class="spotButton" appDbclick (debounceClick)="openOwnFleetDriver();">
                <div class="button">
                    <img src="assets/Own-Driver.svg" alt="">
                    <span class="label">
                        {{'spotOn.addOwnFleet' | translate}}
                    </span>
                </div>
            </div> -->

      <div class="submit_buttons">
        <div>
          <div
            class="button create_cancel_btn"
            appDbclick
            (debounceClick)="createTrip()"
          >
            {{ "Cancel" | translate }}
          </div>
          <div
            class="button create_trip_btn"
            appDbclick
            (debounceClick)="createTrip()"
          >
            {{ "Create Trip" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #warning>
  <div class="warning">
    <div class="section">
      <div class="header">
        <div class="label">
          {{ "ASSIGN.warning" | translate
          }}<i class="material-icons" (click)="dialogRef.close(false)">clear</i>
        </div>
      </div>
      <div class="text">
        {{ inServiceVehicleNo }} {{ "ASSIGN.warningText" | translate }}
      </div>
      <div class="submitButton">
        <div class="button" (click)="dialogRef.close(true)">
          {{ "ASSIGN.ok" | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
